import { render, staticRenderFns } from "./PlatformSetup.vue?vue&type=template&id=3904c3b0&scoped=true"
import script from "./PlatformSetup.vue?vue&type=script&lang=js"
export * from "./PlatformSetup.vue?vue&type=script&lang=js"
import style0 from "./PlatformSetup.vue?vue&type=style&index=0&id=3904c3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3904c3b0",
  null
  
)

export default component.exports